import React from 'react';
import { EntityTaskDetails } from 'components/common/tasks/entityTaskDetails';
import { useParams } from 'react-router-dom';
import { usePurchaseRequestByIdQuery } from 'api';

export const PurchaseRequestTaskDetails = () => {
  const { id } = useParams() as { id: string };
  const { data: { purchaseRequest = {} } = {} } = usePurchaseRequestByIdQuery({ id }, { skip: !id });
  return <EntityTaskDetails entityName={'PURCHASE_REQUEST'} isFinalStatus={purchaseRequest.isFinalStatus} />;
};
